import {ICON_TYPES} from '../constants';

export const TvCableIcon = (): JSX.Element => {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M21 16.625V5.25C21 4.55381 20.7234 3.88613 20.2312 3.39384C19.7389 2.90156 19.0712 2.625 18.375 2.625H2.625C1.92881 2.625 1.26113 2.90156 0.768845 3.39384C0.276562 3.88613 0 4.55381 0 5.25L0 16.625H9.625V17.5H6.125V19.25H14.875V17.5H11.375V16.625H21ZM1.75 5.25C1.75 5.01794 1.84219 4.79538 2.00628 4.63128C2.17038 4.46719 2.39294 4.375 2.625 4.375H18.375C18.6071 4.375 18.8296 4.46719 18.9937 4.63128C19.1578 4.79538 19.25 5.01794 19.25 5.25V14.875H1.75V5.25Z'
          fill='#43494F'
        />
      </g>
    </svg>
  );
};

TvCableIcon.iconType = ICON_TYPES.TV_CABLE;
